import { useSearch } from "@tanstack/react-router"
import { useAuthInviteQuery } from "modules/auth/hooks/useAuthInviteQuery"
import { useTranslation } from "react-i18next"
import { AuthInviteResponseData } from "schema"
import { AuthWrapper } from "../AuthWrapper"
import { SignupWithTokenForm } from "./SignupWithTokenForm"
import { Loading } from "modules/shared/components/Loading"

function FetchingToken() {
  return (
    <div className="flex justify-center items-center py-6">
      <Loading />
    </div>
  )
}

function TokenNotFound() {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col space-y-4 text-center">
      <h1 className="text-2xl font-semibold tracking-tight">
        {t("auth.signupWithToken.tokenNotFound.title")}
      </h1>
      <p className="text-sm">{t("auth.signupWithToken.tokenNotFound.description")}</p>
    </div>
  )
}

type TokenFoundProps = {
  token: string
  data: AuthInviteResponseData
}

function TokenFound({ token, data }: TokenFoundProps) {
  const { senderName, name, email } = data
  return <SignupWithTokenForm token={token} senderName={senderName} name={name} email={email} />
}

export const SignupWithToken = () => {
  const searchParams = useSearch({ from: "/_base/_public/invite" })
  const { data, status } = useAuthInviteQuery({ token: searchParams.token })

  function renderContent() {
    if (status === "pending") return <FetchingToken />
    if (status === "error" || !data) return <TokenNotFound />
    return <TokenFound token={searchParams.token} data={data} />
  }

  return <AuthWrapper>{renderContent()}</AuthWrapper>
}
